import moment from 'moment';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import ClubImage from '../../../components/ClubImage/ClubImage';
import DefaultContainer from '../../../components/DefaultContainer/DefaultContainer';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import Icon from '../../../components/Icon/Icon';
import { getClub } from '../../../service/clubs';
import { deleteVote, getCandidatesByElectionId, getElection, getElectionsByUserId, getElectionResult, getUserVoteByUserAndElectionId, insertVote } from '../../../service/election';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';
import { useUserStore } from '../../../store/useUser';
import { button_color, main_color_50 } from '../../../styles/_variables';

import styles from './Candidates.module.scss';

const MeetCandidates = () => {
  const location = useLocation();

  const userId = useUserStore(state => state.id)
  const profile = useUserStore(state => state.profile)

  const path = location.pathname.split('/')
  const electionId = path[4]

  const {data:ballotBox, isFetching, refetch } = useQuery(
    ['ballotBox', electionId],
    () => getUserVoteByUserAndElectionId(userId, Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const {data:candidates, isFetching: isFetchingCandidates} = useQuery(
    ['candidates', electionId],
    () => getCandidatesByElectionId(Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const {data:election} = useQuery(
    ['election', electionId],
    () => getElection(Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const electionIsFinish = new Date(election?.finalDate) < new Date()

  const {data:result} = useQuery(
    ['result', Number(electionId)],
    () => getElectionResult(Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled:electionIsFinish},
  );

  return (
    <div className={styles.container}>
      <HeaderPage bageColor={main_color_50} header='Candidatos' />
      {electionIsFinish && <DefaultContainer>Próxima data já decidida!</DefaultContainer>}
      {candidates?.map((candidate, index) => 
          <section className={`${styles.candidateContainer} ${result && result[0]?.candidateId === candidate.id && styles.winner}` }>
            <div className={styles.candidateHeader}>
              <div>Data {index + 1}</div>
              <div className={styles.candidateVotes}>{candidate.votes} votos</div>
            </div>
            <div>{moment(candidate?.candidate).format('DD/MM/YYYY HH:mm')}</div>
            { ballotBox?.candidateId === candidate.id &&  
                <Check 
                  electionIsFinish={electionIsFinish}
                  refetch={refetch} candidate={candidate?.id}/> 
            } 
            { !ballotBox?.id && 
                  <BallotBox
                    electionIsFinish={electionIsFinish}
                    refetch={refetch} 
                    candidate={candidate?.id}/>
            }
          </section>
      )}
      {!candidates?.length && !isFetchingCandidates 
        ? "Ops, parece que está vazio." : null}
    </div>
  )
}

export const Check = ({candidate, refetch, electionIsFinish}) => {
  const location = useLocation();
  const profile = useUserStore(state => state.profile)

  const path = location.pathname.split('/')
  const electionId = path[4]

  const userId = useUserStore(state => state.id)

  if(profile === 'Criador' || profile === 'Mediador' ) return null;

  const handleClick = async () => {
    if(electionIsFinish) return;

    const {error, success} = await deleteVote(Number(electionId), userId, candidate)
    
    if(error) {
      return createErrorNotification('Algo deu errado, tente novamente')
    }

    refetch()

    createSuccessNotification('Excluido!');
  }

  return (
    <div className={styles.check} onClick={handleClick}>
      <Icon icon='check' color={button_color} />
        Votado
      </div>
  )
}

export const BallotBox = ({candidate, refetch, electionIsFinish}) => {
  const location = useLocation();

  const path = location.pathname.split('/')
  const profile = useUserStore(state => state.profile)

  const electionId = path[4]

  const userId = useUserStore(state => state.id)

  if(electionIsFinish) return null;

  if(profile === 'Criador' || profile === 'Mediador' ) return null;


  const handleClick = async () => {
    const {error, success} = await insertVote(Number(electionId), userId, candidate)

    if(error) {
      return createErrorNotification('Algo deu errado, tente novamente')
    }

    refetch()
    createSuccessNotification('Votado!');
  }

  return (
    <button className={styles.check} onClick={handleClick}>
      <Icon icon='ballotbox' color={button_color} />
        Votar
    </button>
  )
}


export const Club = ({clubId}) => {
  const {data:club, isFetching} = useQuery(
    ['club', clubId],
    () => getClub(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return (
      <div >
        <header className={styles.clubHeader}>
          <ClubImage clubName={club?.name} path={club?.pathPhoto}/>
        <strong>{club?.name}</strong>
      </header>
    </div>
  )
}

export default MeetCandidates;